import { render, staticRenderFns } from "./use-case-card.vue?vue&type=template&id=64b602cc&"
import script from "./use-case-card.vue?vue&type=script&lang=ts&"
export * from "./use-case-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports